<template>
  <div>
    <!-- Pricing Table Starts -->
    <section class="pricing-table section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 fadeInLeftBig animated">
            <div class="section-top text-center">
              <!-- <h2></h2> -->
              <p class="row-p">{{ soluConents }}</p>
            </div>
          </div>
        </div>
        <div class="row fadeInRightBig animated">
          <div class="col-md-4" v-for="(v, i) in solutionsList" :key="i">
            <div class="single-table text-center mb-4 mb-md-0">
              <div class="table-top">
                <h3>{{ v.name }}</h3>
                <!-- <i class="fa fa-home">{{ v.description }}</i> -->
              </div>
              <div style="padding: 30px;">
                {{ v.description }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Pricing Table End -->

  </div>
</template>

<script>
export default {
  name: 'solutions',
  data () {
    return {
      soluConents: '公司团队多年来在核电、火电、水电、风电、采矿等资产密集型企业信息化实施开发的经验反复验证和表明，一个成功的企业管理信息化项目全面解决方案，必须完整包括所选用软件平台、行业支撑知识库、实施方法论，这三者缺一不可，构成对解决方案三位一体的托举支撑。公司目前已培育成熟“电力企业ERP数字化管理解决方案”和“大数据商业智能解决方案”两个完整的解决方案能够快速实施部署和交付给目标客户。',
      solutionsList: [{
        name: '电力企业ERP数字化管理解决方案',
        description: '公司和长江电力通过长期合作共研的ePMS系统已发展成为一个电力企业ERP数字化管理解决方案，是一个多公司管理架构下的以电站资产维护管理和企业经营管理为双核心的大型ERP数字化管理平台，能同时满足企业集团化下跨区域大型电站群及梯级流域电站生产管理和以人财物为优化对象的企业经营管理的需要。'
      },
      {
        name: '大数据商业智能解决方案',
        description: '商业智能（BI）现代数据仓库技术、线上分析处理技术、数据挖掘和数据展现技术进行数据分析以实现商业价值，通过处理企业中现有数据，并将其转换成知识、分析和结论，辅助业务或者决策者做出正确的决定。'
      }
      ]
    }
  }
}
</script>
<style scoped>
.row {
  justify-content: center;
}



.single-table {
  height: 400px;
}

@media (min-width: 768px) {

  .col-md-4 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
.row-p{
  color: rgb(0,0,0);
  font-style: normal;
}
</style>




// WEBPACK FOOTER //
// Solutions.vue?4e8b3ef1